import { Builder } from "@olga-food/schemas/lib/classes/schemas/catalog/Builder";
import { Currency } from "./Currency";

export class CatalogHelpers {
  static executeOnSchema(item, callback) {
    for (let field of ["items", "extra_ingredients", "sizes"]) {
      if (item[field] && item[field].length > 0) {
        for (let children of item[field]) {
          CatalogHelpers.executeOnSchema(children, callback);
          callback(children, item, field);
        }
      }
    }
  }

  static calculateSelectedItemPrice(item) {
    if (item.type !== "pizza") {
      const itemCopy = JSON.parse(JSON.stringify(item));

      const preparedItem = CatalogHelpers.clearUnselectedItems(
        itemCopy
      )
      const mountedItem = Builder.mountSchema(preparedItem);

      return +mountedItem.getPrice().toFixed(2);
    } else {
      const pizza = Builder.mountSchema(JSON.parse(JSON.stringify(item)));
      return pizza.getPrice();
    }
  }

  static clearUnselectedItems(item) {
    const props = ["items", "sizes", "extra_ingredients", "doughs", "edges"];
    for (const key of props) {
      if (item[key] && item[key].length > 0) {
        for (const subItemIndex in item[key]) {
          item[key][subItemIndex] = CatalogHelpers.clearUnselectedItems(
            item[key][subItemIndex]
          );
        }

        item[key] = item[key].filter((i) => i.selected !== false);
        if (item[key].length > 0) {
          item.selected = true;
        }
      }
    }
    return item;
  }

  static isPromotionalPrice(product) {
    if (!product?.sizes || product?.sizes?.length <= 0) return false;

    return !!product.sizes.find((size) => size.promo_price === true);
  }

  static mountPrice(item) {
    if (item.price > 0) {
      return Currency.formatCurrency(Number(item.price));
    }

    if (item.price >= 0 && item.sizes.length === 0) {
      return Currency.formatCurrency(Number(item.price));
    }

    if (item.type == "pizza" && !item.highlight) {
      const flavorPriceArray = [];
      const doughPriceArray = [];
      for (const dough of item.doughs) {
        doughPriceArray.push(...(dough.sizes.map((s) => s.price) || []));
      }
      //Buscar dentre os sabores os menor preço
      for (const flavor of item.items) {
        flavorPriceArray.push(...(flavor.sizes.map((s) => s.price) || []));
      }

      const minDoughPrice =
        doughPriceArray.length > 0 ? Math.min(...doughPriceArray) : 0;
      const minFlavorPrice =
        flavorPriceArray.length > 0 ? Math.min(...flavorPriceArray) : 0;

      return Currency.formatCurrency(minDoughPrice + minFlavorPrice);
    }

    if (item.sizes.length > 0) {
      const minValue = Math.min(
        ...((item.sizes || []).map((s) => s.price || 0) || [0])
      );

      const minPrices = item.items?.map((question) => {
        if (!question.min) {
          return 0;
        }

        const minOptionPrice =
          question.items.length > 0
            ? Math.min(
                ...(question.items.map(
                  (options) => options.price * question.min
                ) || [0])
              )
            : 0;
        return minOptionPrice;
      });

      return Currency.formatCurrency(
        Number(minValue + minPrices?.reduce((s, v) => s + v, 0))
      );
    }
  }

  static mountOldPrice(item) {
    if (item.old_price > 0) {
      return Currency.formatCurrency(Number(item.old_price));
    }

    if (item.old_price >= 0 && item.sizes.length === 0) {
      return Currency.formatCurrency(Number(item.old_price));
    }

    if (item.type == "pizza" && !item.highlight) {
      const flavorPriceArray = [];
      const doughPriceArray = [];
      for (const dough of item.doughs) {
        doughPriceArray.push(...(dough.sizes.map((s) => s.old_price) || []));
      }
      //Buscar dentre os sabores os menor preço
      for (const flavor of item.items) {
        flavorPriceArray.push(...(flavor.sizes.map((s) => s.old_price) || []));
      }

      const minDoughPrice =
        doughPriceArray.length > 0 ? Math.min(...doughPriceArray) : 0;
      const minFlavorPrice =
        flavorPriceArray.length > 0 ? Math.min(...flavorPriceArray) : 0;

      return Currency.formatCurrency(minDoughPrice + minFlavorPrice);
    }

    if (item.sizes.length > 0) {
      const minValue = Math.min(
        ...((item.sizes || []).map((s) => s.old_price || 0) || [0])
      );

      const minPrices = item.items?.map((question) => {
        if (!question.min) {
          return 0;
        }

        const minOptionPrice =
          question.items.length > 0
            ? Math.min(
                ...(question.items.map(
                  (options) => options.price * question.min
                ) || [0])
              )
            : 0;
        return minOptionPrice;
      });

      if (Number(minValue + minPrices?.reduce((s, v) => s + v, 0)) === 0)
        return null;

      return Currency.formatCurrency(
        Number(minValue + minPrices?.reduce((s, v) => s + v, 0))
      );
    }
  }

  static getTranslation({ item, field, locale }) {
    if (!locale) {
      locale = 'pt-br';
    }

    if (locale === 'pt-br') {
      return item[field]?.["pt-br"] || item[field];
    }

    if (!(typeof item.name === "string")) {
      return item[field]?.[locale] || item[field]?.["pt-br"] || item[field];
    }

    return item.translation?.[field]?.[locale] || item[field];
  }
}
